import OrderAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order/order.entity";
import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule, Sort } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";

@Component({
  selector: "app-table-list-client",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatPaginatorModule,
  ],
  templateUrl: "./table-list-client.component.html",
  styleUrl: "./table-list-client.component.scss",
})
export class TableListClientComponent {
  @Input() summaryData: any[] | null = null;
  @ViewChild(MatSort, { static: false }) sortTable!: MatSort;
  @Input() servicesFuntion: (sortOrder: string, pageIndex?: number) => void;
  @Output() searchChange: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ["name"];
  dataSource = new MatTableDataSource([]);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["summaryData"] && this.summaryData) {
      this.dataSource.data = this.summaryData;

      this.dataSource.sortingDataAccessor = (data: any, headerId: string) => {
        switch (headerId) {
          case "name":
            return data.soldTo?.name?.toLowerCase() || "";
        }
      };
    }
  }

  public onSearchChange(event) {
    const search = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    this.dataSource.data = this.summaryData.filter((data: any) => {
      return data?.soldTo?.name.toLowerCase().includes(search);
    });
  }

  public onSortChange(sort: Sort) {
    const sortColumn = sort.active; // Columna que se está ordenando
    let sortDirection = sort.direction.toUpperCase();
    this.servicesFuntion(sortDirection);
  }

  public onSearchInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this.searchChange.emit(target.value.trim());
  }

  public updateData(data: OrderAttributes[]) {
    this.dataSource.data = data;
  }
}
